<template>
    <span class="info-icon">
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 17.75C11.8019 17.7474 11.6126 17.6676 11.4725 17.5275C11.3324 17.3874 11.2526 17.1981 11.25 17V10C11.25 9.80109 11.329 9.61032 11.4697 9.46967C11.6103 9.32902 11.8011 9.25 12 9.25C12.1989 9.25 12.3897 9.32902 12.5303 9.46967C12.671 9.61032 12.75 9.80109 12.75 10V17C12.7474 17.1981 12.6676 17.3874 12.5275 17.5275C12.3874 17.6676 12.1981 17.7474 12 17.75Z"
                :fill="fill"
            />
            <path
                d="M12 8.25C11.8019 8.24741 11.6126 8.16756 11.4725 8.02747C11.3324 7.88737 11.2526 7.69811 11.25 7.5V7C11.25 6.80109 11.329 6.61032 11.4697 6.46967C11.6103 6.32902 11.8011 6.25 12 6.25C12.1989 6.25 12.3897 6.32902 12.5303 6.46967C12.671 6.61032 12.75 6.80109 12.75 7V7.5C12.7474 7.69811 12.6676 7.88737 12.5275 8.02747C12.3874 8.16756 12.1981 8.24741 12 8.25Z"
                :fill="fill"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconInfo',
    props: {
        fill: {
            type: String,
            default: '#fff',
        },
    },
};
</script>
